/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { updateCenterGraph } from "./updateCenterGraph";
import jobFields from "../store/constants/jobFields"
import store from "../store/store";
import { setDataChartDuration, setDataChartStartTime, setLastDefinitionChangesData, setLastTenRunsChart, setLastTenRunsTable, updateSelectedJobData } from "../store/slice/roomSlices/jobRoomSlice";

export const updateJobRoom = (path, data) => {
	const dispatch = store.dispatch;

	const keys = path.split("/:");
	const root = keys[0];
	const field = keys[1];

	switch (root) {
		case jobFields.CENTER_GRAPH:
			updateCenterGraph(dispatch, data)
			break;

		case jobFields.SELECTED_JOB:
			dispatch(updateSelectedJobData({ field, data }))
			break;

		case jobFields.DATA_CHART_START_TIME:
			dispatch(setDataChartStartTime(data))
			break;

		case jobFields.DATA_CHART_DURATION:
			dispatch(setDataChartDuration(data))
			break;

		case jobFields.LAST_DEFINITION_CHANGES_DATA:
			dispatch(setLastDefinitionChangesData(data))
			break;

		case jobFields.LAST_TEN_RUNS_CHART:
			dispatch(setLastTenRunsChart(data))
			break;

		case jobFields.LAST_TEN_RUNS_TABLE:
			dispatch(setLastTenRunsTable(data))
			break;

		default:
			console.log("not yet implemented case", path, data)
			break;
	}
};